import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';

import { BaseWebService } from "../../services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class StripeAddNewPaymentService {
    constructor(
        private readonly _basewebservice: BaseWebService
    ) { }

    getStripePaymentIntent(postData: any) {
        const data: any = {};
        data.body = postData;
        return this._basewebservice.request("v1/payments/practice/setup/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    confirmPaymentMethod(postData: any) {
        const data: any = {};
        data.body = postData;
        return this._basewebservice.request("v1/payments/payment-methods/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
} 